import { Button } from "@mui/material";
import PropTypes from "prop-types";
import AccessDeniedNotice from "./AccessDeniedNotice.jsx";
import { PORTAL } from "../../theme/portals.js";
import { getEnv } from "../../env.js";
import { useLogout } from "../../hooks/useLogout.js";

const OTHER_PORTAL = {
  [PORTAL.SCHADENPORTAL]: PORTAL.KUNDENPORTAL,
  [PORTAL.KUNDENPORTAL]: PORTAL.SCHADENPORTAL,
};

const PORTAL_LABELS = {
  [PORTAL.SCHADENPORTAL]: "Schadenportal",
  [PORTAL.KUNDENPORTAL]: "Kundenportal",
};

const PORTAL_URL_ENV = {
  [PORTAL.SCHADENPORTAL]: "VITE_SCHADENPORTAL_URL",
  [PORTAL.KUNDENPORTAL]: "VITE_KUNDENPORTAL_URL",
};

/**
 * Shown instead of a portal's content when the signed-in user's `portals`
 * does not include the portal they are currently on. Reloading or "Zur
 * Startseite" would just land back here, so this replaces those default
 * actions with a link to the other portal - only when the user may enter it
 * - and a logout.
 *
 * @param {string} portal - The portal being denied (a `PORTAL` value)
 * @param {string[]} [portals] - The portals the signed-in user may enter
 */
export default function PortalAccessDenied({ portal, portals = [] }) {
  const handleLogout = useLogout();
  const other_portal = OTHER_PORTAL[portal];
  const may_use_other_portal = portals.includes(other_portal);

  return (
    <AccessDeniedNotice
      message={`Sie haben keinen Zugriff auf das ${PORTAL_LABELS[portal]}.`}
      actions={
        <>
          {may_use_other_portal && (
            <Button
              variant="outlined"
              href={getEnv(PORTAL_URL_ENV[other_portal])}
            >
              Zum {PORTAL_LABELS[other_portal]}
            </Button>
          )}
          <Button variant="contained" onClick={handleLogout}>
            Abmelden
          </Button>
        </>
      }
    />
  );
}

PortalAccessDenied.propTypes = {
  portal: PropTypes.oneOf(Object.values(PORTAL)).isRequired,
  portals: PropTypes.arrayOf(PropTypes.string),
};
